import { render, staticRenderFns } from "./ishowVendorRequest.vue?vue&type=template&id=1af9c91a"
import script from "./ishowVendorRequest.vue?vue&type=script&lang=js"
export * from "./ishowVendorRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports